/* RESPONSIBLE TEAM: team-standalone */
/* eslint-disable @intercom/intercom/no-bare-strings */
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

// In the backend, these are defined in app/lib/standalone/constants/connection_types.rb
export enum ConnectionType {
  TestConnection = -100, // Use only within specs for setting up generic platforms
  SuiteConnection = -1, // Used when a standalone app is migrated to suite
  ZendeskSunshineApi = 1,
  ZendeskApi = 2,
  SalesforceApi = 3,
  FreshdeskApi = 6,
  FreshchatApi = 8,
  FrontApi = 15,
  HubspotApi = 16,
}

export const CONNECTION_TYPE_ICONS: Partial<Record<ConnectionType, InterfaceIconName>> = {
  [ConnectionType.ZendeskSunshineApi]: 'zendesk',
  [ConnectionType.ZendeskApi]: 'zendesk',
  [ConnectionType.SalesforceApi]: 'salesforce',
  [ConnectionType.FreshdeskApi]: 'freshdesk',
  [ConnectionType.FreshchatApi]: 'freshdesk',
  [ConnectionType.FrontApi]: 'info',
  [ConnectionType.HubspotApi]: 'hubspot',
};

export const CONNECTION_TYPE_DISPLAY_NAMES: Partial<Record<ConnectionType, string>> = {
  [ConnectionType.SuiteConnection]: 'Intercom Suite',
  [ConnectionType.ZendeskSunshineApi]: 'Fin for Zendesk',
  [ConnectionType.ZendeskApi]: 'Fin for Zendesk',
  [ConnectionType.SalesforceApi]: 'Fin for Salesforce',
  [ConnectionType.FreshdeskApi]: 'Fin for Freshdesk',
  [ConnectionType.FreshchatApi]: 'Fin for Freshdesk',
  [ConnectionType.FrontApi]: 'Fin for Front',
  [ConnectionType.HubspotApi]: 'Fin for Hubspot',
};
